import { Rectangle } from 'recharts';

function OwnerCertificationChartTooltipCursor(props: any) {
  const {
    x,
    y,
    payload,
    stroke,
    pointerEvents,
    width,
    height,
    points,
    className,
  } = props;
  const { isLast } = payload[0].payload;

  if (isLast) return null;
  return (
    <Rectangle
      fill="#FAFAFA"
      x={x}
      y={y}
      width={width}
      height={height}
      fillOpacity={1}
      pointerEvents={pointerEvents}
      points={points}
      className={className}
      type="linear"
    />
  );
}

export default OwnerCertificationChartTooltipCursor;
